import { cityStage } from '../city/stages';
import type { ModelProps } from '../parts';

const CITY_SCALE = 1.12;

/** The city, drawn as its level's stage (`CITY_STAGES`). */
export function City(props: ModelProps) {
  const Stage = cityStage(props.level);
  return (
    <group scale={CITY_SCALE}>
      <Stage {...props} />
    </group>
  );
}
